<div class="mobilemenu" [ngClass]="{'mobilemenu--open': isOpen,'mobilemenu--close':(mobilemenu.isClose$|async)}">
    <div class="mobilemenu__backdrop" (click)="mobilemenu.close()"></div>
    <div class="mobilemenu__body align-end">


         <div *ngIf="userDetails" class="user-info-section">
            <a [routerLink]="['/account/dashboard']" class="user-info" (click)="mobilemenu.close()">
                <div class="user-info__details">
                    <div class="user-info__name">{{userDetails.name}}</div>
                    <div class="user-info__email">{{userDetails.email}}</div>
                </div>
            </a>
        </div>

        <div *ngIf="!userDetails" class="auth-links-section">
            <a [routerLink]="['/login']" class="auth-link login-link" (click)="mobilemenu.close()">
                <mat-icon fontIcon="login"></mat-icon>
                <span>{{"log_in"|translate}}</span>
            </a>
            <a [routerLink]="['/register']" class="auth-link register-link" (click)="mobilemenu.close()">
                <mat-icon fontIcon="person_add"></mat-icon>
                <span>{{"create_account"|translate}}</span>
            </a>
        </div>

        <div class="mobilemenu__divider"></div>
        <div class="language-section">
            <span class="language-label">{{"language" | translate}}</span>
            <div class="language-switcher">
                <button 
                    class="language-btn" 
                    [class.active]="translateService.currentLang == 'en'"
                    (click)="changeLangage('en')"
                    type="button">
                    EN
                </button>
                <button 
                    class="language-btn" 
                    [class.active]="translateService.currentLang == 'ar'"
                    (click)="changeLangage('ar')"
                    type="button">
                    AR
                </button>
            </div>
        </div>

        <div class="mobilemenu__divider"></div>


        <div class="mobilemenu__divider"></div>

        <div class="m-2">
            <span class="selector-label">{{"country"|translate}}</span>
            <app-country-select variant="menu" styleClass="mobile-country-selector"></app-country-select>
        </div>

        
        <div class="mobilemenu__divider"></div>

       

        <a (click)="mobilemenu.close()" [routerLink]="['/account/dashboard']" class="flex flex-row m-3 color-inherit">
            <span class="mobile-links__item-link">{{"profile"|translate}}</span>
        </a>

        <div class="mobilemenu__divider"></div>

        <a *ngIf="userDetails?.isVendor; else becomeVendor" href="/admin" target="_blank"
            class="flex flex-row m-3 color-inherit">
            <span class="mobile-links__item-link">{{"admin_panel"|translate}}</span>
        </a>
        <ng-template #becomeVendor>
            <a *ngIf="!siteService.siteSetting?.companyId" [routerLink]="['/apply-for-vendor']"
                class="flex flex-row m-3 color-inherit" (click)="mobilemenu.close()">
                <span class="mobile-links__item-link">{{"become_vendor"|translate}}</span>
            </a>
        </ng-template>

        <a (click)="mobilemenu.close()" *ngIf=" siteService.features?.quotationRequests" [routerLink]="['/rfq/center']"
            class="flex flex-row m-3 color-inherit">
            <span class="mobile-links__item-link">{{"rfq_center"|translate}}</span>
        </a>
        <div class="mobilemenu__divider"></div>

        <!-- <a (click)="mobilemenu.close()" *ngIf="siteService.features?.quotationRequests" [routerLink]="['/request-quotation']" class="flex flex-row m-3 color-inherit">
            <span class="mobile-links__item-link">{{"request_quotation"|translate}}</span>
        </a> -->

        <div class="mobilemenu__divider"></div>

        <a (click)="mobilemenu.close()" [routerLink]="['/site', 'stores']" class="flex flex-row m-3 color-inherit">
            <span class="mobile-links__item-link">{{"stores"|translate}}</span>
        </a>

        <a (click)="mobilemenu.close()" *ngIf="siteService.features?.professionals" [routerLink]="['/site', 'professionals']" class="flex flex-row m-3 color-inherit">
            <span class="mobile-links__item-link">{{"professionals"|translate}}</span>
        </a>

        <div class="mobilemenu__divider"></div>

        <a (click)="mobilemenu.close()" [routerLink]="['/compare']" class="flex flex-row m-3 color-inherit">
            <span class="mobile-links__item-link">{{"compare"|translate}}</span>
        </a>
        <div class="mobilemenu__divider"></div>

        <a (click)="mobilemenu.close()" *ngIf="!siteService.siteSetting?.companyId && siteService.features?.askQetaat"
            [routerLink]="['/ask-qetaat']" class="flex flex-row m-3 color-inherit">
            <span class="mobile-links__item-link">{{"ask_qetaat"|translate}}</span>
        </a>
        <div class="mobilemenu__divider"></div>

        <a (click)="mobilemenu.close()" *ngIf="!siteService.siteSetting?.companyId && siteService.features?.blogs"
            [routerLink]="['/blog']" class="flex flex-row m-3 color-inherit">
            <span class="mobile-links__item-link">{{"blog"|translate}}</span>
        </a>

        <div class="mobilemenu__divider"></div>

            <a (click)="mobilemenu.close()" [routerLink]="['/recruit']" class="flex flex-row m-3 color-inherit">
                <span class="mobile-links__item-link">{{ translateService.currentLang === 'en' ? 'Careers' : 'وظائف' }}</span>
            </a>
            
            <div class="mobilemenu__divider"></div>

            <a (click)="logout()" *ngIf="userDetails" class="flex flex-row m-3 color-inherit logout-button">
                <span class="mobile-links__item-link">{{"logout"|translate}}</span>
            </a>

        <div class="mobilemenu__content" *ngIf="deviceDetector.isMobile()">
            <ul class="mobile-links mobile-links--level--0" appCollapse>
                <li *ngFor="let page of staticPages|keyvalue">
                    <div class="mobile-links__item" appCollapseItem="mobile-links__item--open"
                        #footerLinks="appCollapseItem">
                        <div class="mobile-links__item-title" (click)="footerLinks.toggle()">
                            <div class="mobile-links__item-link">{{page.key|translate}}</div>
                            <!-- <a class="mobile-links__item-link" (click)="onItemClick(link)">{{ link.label }}</a> -->
                            <button class="mobile-links__item-toggle" type="button">
                                <app-icon class="mobile-links__item-arrow" name="arrow-rounded-down-12x7" size="12x7">
                                </app-icon>
                            </button>
                        </div>
                        <div class="mobile-links__item-sub-links" appCollapseContent>
                            <ul class="mobile-links mobile-links--level--1" appCollapse>
                                <li *ngFor="let link of page.value">
                                    <div class="mobile-links__item">
                                        <div class="mobile-links__item-title">
                                            <a class="mobile-links__item-link"
                                                [routerLink]="['/page',link?.seo?.slug]">{{
                                                translateHelper.localize(link.name) }}</a>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="mobile-links__item" appCollapseItem="mobile-links__item--open"
                        #contactUs="appCollapseItem">
                        <div class="mobile-links__item-title" (click)="contactUs.toggle()">
                            <div class="mobile-links__item-link">{{"contact_us"|translate}}</div>
                            <!-- <a class="mobile-links__item-link" (click)="onItemClick(link)">{{ link.label }}</a> -->
                            <button class="mobile-links__item-toggle" type="button">
                                <app-icon class="mobile-links__item-arrow" name="arrow-rounded-down-12x7" size="12x7">
                                </app-icon>
                            </button>
                        </div>
                        <div class="mobile-links__item-sub-links" *ngIf="siteService.siteSetting?.contactUs"
                            appCollapseContent>
                            <ul class="mobile-links mobile-links--level--1" appCollapse>
                                <li *ngIf="siteService.siteSetting.contactUs.phone">
                                    <div class="mobile-links__item">
                                        <div class="mobile-links__item-title">
                                            <div class="mobile-links__item-link"><i
                                                    class="footer-contacts__icon fas fa-mobile-alt"></i> <span
                                                    style="direction: ltr;">{{siteService.siteSetting.contactUs.phone}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li *ngIf="siteService.siteSetting.contactUs.timing">
                                    <div class="mobile-links__item">
                                        <div class="mobile-links__item-title">
                                            <div class="mobile-links__item-link"><i
                                                    class="footer-contacts__icon far fa-clock"></i>
                                                {{siteService.siteSetting.contactUs.timing}}
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li *ngIf="siteService.siteSetting.contactUs.email">
                                    <div class="mobile-links__item">
                                        <div class="mobile-links__item-title">
                                            <div class="mobile-links__item-link"><i
                                                    class="footer-contacts__icon far fa-envelope"></i>
                                                {{siteService.siteSetting.contactUs.email}}
                                            </div>
                                        </div>
                                    </div>
                                </li>

                                <li *ngIf="siteService.siteSetting.contactUs.address">
                                    <div class="mobile-links__item">
                                        <div class="mobile-links__item-title">
                                            <div class="mobile-links__item-link d-flex">
                                                <i class="footer-contacts__icon fas fa-globe-americas"></i>
                                                {{siteService.siteSetting.contactUs.address}}
                                            </div>
                                        </div>
                                    </div>
                                </li>

                                <li *ngIf="siteCompany">
                                    <div class="mobile-links__item">
                                        <div class="mobile-links__item-title">
                                            <div class="mobile-links__item-link d-flex">
                                                <i class="footer-contacts__icon fas fa-globe-americas"></i>
                                                <div *ngIf="siteCompany.crNumber">{{"cr"|translate}}
                                                    111111111{{siteCompany?.crNumber}}</div>
                                                <div *ngIf="siteCompany.vatCertificate">{{"vatr"|translate}}
                                                    12321321321{{siteCompany?.vatCertificate}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </li>


                            </ul>
                        </div>

                        <!-- #DEP to be deprecated -->

                        <div class="mobile-links__item-sub-links" *ngIf="!siteService.siteSetting?.contactUs"
                            appCollapseContent>
                            <ul class="mobile-links mobile-links--level--1" appCollapse>
                                <li>
                                    <div class="mobile-links__item">
                                        <div class="mobile-links__item-title">
                                            <div class="mobile-links__item-link"><i
                                                    class="footer-contacts__icon fas fa-mobile-alt"></i> <span
                                                    style="direction: ltr;">13380333</span></div>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="mobile-links__item">
                                        <div class="mobile-links__item-title">
                                            <div class="mobile-links__item-link"><i
                                                    class="footer-contacts__icon far fa-clock"></i> Sun-Thu 8:00 - 17:00
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="mobile-links__item">
                                        <div class="mobile-links__item-title">
                                            <div class="mobile-links__item-link"><i
                                                    class="footer-contacts__icon far fa-envelope"></i>
                                                info&#64;qetaat.com
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="mobile-links__item">
                                        <div class="mobile-links__item-title">
                                            <div class="mobile-links__item-link"><i
                                                    class="footer-contacts__icon far fa-envelope"></i>
                                                order&#64;qetaat.com
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="mobile-links__item">
                                        <div class="mobile-links__item-title">
                                            <div class="mobile-links__item-link d-flex">
                                                <i class="footer-contacts__icon fas fa-globe-americas"></i>
                                                <a class="ml-2" href=" https://goo.gl/maps/vJAf5EhGDL7LYuFo8"> Office
                                                    42, Building 657 (Jeera III), Road 2811, 428 Seef District, Kingdom
                                                    of Bahrain</a>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>

<div class="bottom-nav d-flex justify-content-center">
   <!--  @if(location()=='homepage'){ -->
    <button class="nav-item" (click)="searchDropdownToggle($event);">
        <div class="nav-icon">
            <mat-icon fontSet="material-symbols-outlined">search</mat-icon>
        </div>
        <div class="nav-label capitalize">{{"search"|translate}}</div>
    </button>
    <!-- <a class="nav-item" (click)="onItemClick($event)" [routerLink]="(['/']).concat(['site','stores'])">
        <div class="nav-icon">
            <mat-icon fontSet="material-symbols-outlined">store</mat-icon>
        </div>
        <div class="nav-label capitalize">{{"stores"|translate}}</div>
    </a> -->
    <!-- <a *ngIf="siteService.features?.quotationRequests" class="nav-item" (click)="onItemClick($event)"
        [routerLink]="['/rfq/center']">
        <div class="nav-icon">
            <mat-icon fontSet="material-symbols-outlined">recenter</mat-icon> -->
            <!--  <div class="badge">{{quotationCart.quantity$|async}}</div> -->
        <!-- </div>
        <div class="nav-label capitalize">{{"rfq_center"|translate}}</div>
    </a> -->
    <a class="nav-item" (click)="onItemClick($event)" [routerLink]="['/cart']">
        <div class="nav-icon">
            <mat-icon fontSet="material-symbols-outlined">shopping_cart</mat-icon>
            <div class="badge">{{cart.quantity$|async}}</div>
        </div>
        <div class="nav-label capitalize">{{"cart"|translate}}</div>
    </a>
    <div class="nav-item country-selector-nav">
        <div class="nav-icon">
            <app-country-select variant="header" styleClass="mobile-country-selector"></app-country-select>
        </div>
        <div class="nav-label capitalize">{{"country"|translate}}</div>
    </div>
<!-- } -->
    <!-- @if(locickon()=='rfq'){ -->
    <!-- <a class="nav-item" (click)="openRfqMenu()">
        <div class="nav-icon">
            <mat-icon fontSet="material-symbols-outlined">menu</mat-icon>
        </div>
        <div class="nav-label capitalize">{{"menu"|translate}}</div>
    </a> -->
    <!-- <a class="nav-item" [routerLink]="['/', translateService.currentLang, 'rfq', 'request']">
        <div class="nav-icon">
            <mat-icon fontSet="material-symbols-outlined">description</mat-icon>
        </div>
        <div class="nav-label capitalize">{{"Get Quote"|translate}}</div>
    </a>
    <a class="nav-item" [routerLink]="['/', translateService.currentLang, 'rfq', 'requests']">
        <div class="nav-icon">
            <mat-icon fontSet="material-symbols-outlined">find_in_page</mat-icon>
        </div>
        <div class="nav-label capitalize">{{"Requests"|translate}}</div>
    </a> -->
    <!-- } -->


    <!-- <a class="nav-item" (click)="onItemClick($event)" [routerLink]="['/account/dashboard']">
        <div class="nav-icon">
            <app-icon name="person-20" size="24"></app-icon>
        </div>
        <div class="nav-label capitalize">{{"profile"|translate}}</div>
    </a> -->

    <app-mobile-browsing-controls></app-mobile-browsing-controls>
</div>